import { Box, GDSStyleObject, StackLayout } from '@leagueplatform/genesis-core';
import { CONTENT_MAX_WIDTH } from '@leagueplatform/web-common-components';
import { useUrlParam } from '@leagueplatform/web-common';
import { useParams } from '@leagueplatform/routing';
import { PageHeaderMobile } from 'components/page-header-mobile/page-header-mobile.component';
import { PropsWithChildren } from 'react';
import { DESKTOP_SINGLE_COLUMN_CONTENT_WIDTH } from 'common/constants';

export const GenericMasonryPageWrapper = ({
  children,
}: PropsWithChildren<{}>) => {
  const { version } = useParams<{ version: string }>();
  const { urlParam: titleString } = useUrlParam('title');

  const wrapperCssMap: { [key: string]: GDSStyleObject } = {
    '1.5': {
      width: '100%',
      maxWidth: DESKTOP_SINGLE_COLUMN_CONTENT_WIDTH,
      '@desktop': {
        marginLeft: '$twoAndHalf',
      },
      '@laptop': {
        marginLeft: '$twoAndHalf',
      },
    },
    '2.0': {
      width: '100%',
    },
  };

  return (
    <StackLayout
      orientation="vertical"
      css={{
        padding: '$none $one',
        marginBottom: '$two',
        '@desktop': {
          padding: '$none $two',
          maxWidth: CONTENT_MAX_WIDTH,
          margin: '$none auto',
          marginBottom: '$two',
        },
      }}
    >
      {titleString && <PageHeaderMobile headingText={titleString} />}
      <Box css={{ ...wrapperCssMap[version || '1.5'] }}>{children}</Box>
    </StackLayout>
  );
};
